module.exports = __webpack_public_path__ + "img/5.08e6bde6.png";